import { render, staticRenderFns } from "./ShareAndEarn.vue?vue&type=template&id=68b3d34e&"
import script from "./ShareAndEarn.vue?vue&type=script&lang=js&"
export * from "./ShareAndEarn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports